import React from 'react';

export default function PdfIcon() {
  return (
    <svg
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className="icon-pdf"
    >
      <title>pdf</title>
      <g id="icons/pdf">
        <path
          className="outer"
          d="M3,13.6600001 L3,5.22377308 L3,5.22377308 C3,
          3.55378935 4.3537893,2.20000005 6.02377303,2.20000005 L6.10313819,
          2.20000005 L12.9691454,2.20000005 L12.9691454,13.6600001 L3,
          13.6600001 Z"
        />
        <path
          className="inner"
          d="M5.41498309,10.7124924 C5.46468818,11.248407 6.89297789,
          9.86509945 7.48161764,8.36174394 C8.06620465,6.86873896 8.36924039,
          5.4000001 7.8536766,5.4000001 C7.40196306,5.4000001 7.52064562,
          7.0387665 8.27555922,8.04998816 C9.03896605,9.07258667 10.8000002,
          9.69185196 10.8000002,9.20256501 C10.8000002,8.93863903 9.35091022,
          8.71694406 8.06620465,9.0811067 C6.54818667,9.51140407 5.38130044,
          10.3493298 5.41498309,10.7124924 Z"
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/PdfIcon.js